<template>
  <div class="web-004-page">
    <carousel
      v-if="cp_carouselImages.length"
      :list="cp_carouselImages"
    />

    <div class="center-container">
      <div class="center-container-middle">
        <div class="center-container-middle-title">
          {{ contentMaps.middle.title }}
        </div>
        <div class="center-container-middle-content">
          <img
            v-for="item in contentMaps.middle.img"
            :key="item"
            class="center-container-middle-content-item"
            :src="item"
            :alt="item"
          >
        </div>
      </div>

      <div class="center-container-bottom">
        <div class="center-container-bottom-content">
          <img
            v-for="item in contentMaps.bottom.img"
            :key="item"
            class="center-container-bottom-content-item"
            :src="item"
            :alt="item"
          >
        </div>
      </div>
      <div class="center-container-top">
        <div class="center-container-top-title">
          商业赋能
        </div>
        <img
          src="@/assets/web004/contactUs/core.png"
          width="1200"
          style="margin-bottom: 10px"
        >
      </div>
    </div>

    <div
      ref="toolsArea"
      class="ruleForm"
      @mousedown.stop="slideBegin($event)"
      @touchstart.stop="slideBegin($event)"
    >
      <div class="title">
        {{ dialogVisible ? '期待与您合作' : '联系我们' }}
      </div>
      <el-form
        v-if="!dialogVisible"
        ref="ruleFormRef2"
        :model="ruleForm"
        :rules="rules"
        label-width="auto"
        size="small"
        status-icon
        label-position="top"
      >
        <el-form-item
          label="您的姓名(已加密，请放心填写)"
          prop="name"
          style="margin-bottom: 22px;"
        >
          <el-input
            v-model="ruleForm.name"
            @focus="isFocus = true;"
            @blur="isFocus = false;"
          />
        </el-form-item>
        <el-form-item
          label="您的电话(已加密，请放心填写)"
          prop="phone"
          style="margin-bottom: 22px;"
        >
          <el-input
            v-model="ruleForm.phone"
            type="number"
            @focus="isFocus = true;"
            @blur="isFocus = false;"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            class="submit"
            :loading="loading"
            @click="submitForm('ruleFormRef2')"
          >
            点击领取项目合作资料
          </el-button>
        </el-form-item>
      </el-form>

      <div
        v-if="dialogVisible"
        class="qr-container"
      >
        <el-image
          :src="'./static/layout/contact.png'"
          class="img"
          width="192px"
          height="192px"
        >
          <div
            slot="error"
            class="image-slot"
          >
            <i class="el-icon-picture-outline" />
          </div>
        </el-image>
      </div>

      <div
        v-if="dialogVisible"
        class="scan-code"
      >
        扫码添加合作顾问
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../proxy';
import carousel from '../../components/carousel.vue';
export default {
    name: 'ContactUs',
    components: {
        carousel,
    },
    data () {
        var validatePhone = (rule, value, callback) => {
            let reg = /^1[0-9]{10,10}$/;
            if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号'));
            } else {
                callback();
            }
        };
        return {
            carouselImages: [],
            loading: false,
            dialogVisible: false,
            ruleForm: {
                name: '',
                phone: '',
            },
            rules: {
                name: [
                    { required: true, message: '请输入您的姓名', trigger: 'blur' },
                    { min: 2, max: 20, message: '长度在20个字符', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入您的电话', trigger: 'change' },
                    { validator: validatePhone, trigger: 'blur' },
                ],
            },

            contentMaps: {
                middle: {
                    title: '教育新模式 投资新风口',
                    img: [require('@/assets/web004/contactUs/middle1.png'), require('@/assets/web004/contactUs/middle2.png'), require('@/assets/web004/contactUs/middle3.png')],
                },
                bottom: {
                    img: [require('@/assets/web004/contactUs/bottom1.png'), require('@/assets/web004/contactUs/bottom2.png'), require('@/assets/web004/contactUs/bottom3.png'), require('@/assets/web004/contactUs/bottom4.png')],
                },
            },

            isFocus: false,
        };
    },
    computed: {
        flatTreeList () {
            return this.$store.getters['system/getFlatTreeList'];
        },
        cp_carouselImages () {
            return this.carouselImages.filter(itm => itm.status === 1 && [0, 1].includes(itm.clientType));
        },
    },
    watch: {
        async flatTreeList (val) {
            if (val.length) {
                const { catalogId, siteId } = this.$route.query;
                const item = val.find(itm => +itm.catalogId === +catalogId);
                if (!item || item.rotation === 0) return;
                const res = item.rotation === 1 ? await api.getRotationList({ siteId, pageNo: 1, pageSize: 999 }) : await api.getCatalogRotationList({ catalogId });
                if (res.errcode === 0) {
                    this.carouselImages = res.data.list || res.data;
                } else {
                    this.$message.error(res.errmsg);
                }
            }
        },
    },
    methods: {
        envjudge () {
            var isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            var isWx = /micromessenger/i.test(navigator.userAgent);
            var isComWx = /wxwork/i.test(navigator.userAgent);

            if (isComWx && isMobile) {
                return 1001; // 手机端企业微信
            } else if (isComWx && !isMobile) {
                return 1003; // PC端企业微信
            } else if (isWx && isMobile) {
                return 1002; // 手机端微信
            } else if (isWx && !isMobile) {
                return 1003; // PC端微信
            } else {
                return 1004; // 其他平台
            }
        },
        submitForm (formName) {
            this.loading = true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        realName: this.ruleForm.name,
                        phone: this.ruleForm.phone,
                        appCode: 1001, // 【非必须】应用编码 1001-智习室
                        sourceCode: 1003, // 【非必须】来源编码 1001-链接A 1002-链接B 1003-官网
                        channelCode: this.envjudge(), // 渠道编码 1001-企微 1002-微信 1003-H5 1004-PC
                    };
                    api.collection(param).then(r => {
                        if (r.errcode === 0) {
                            this.$refs[formName].resetFields();
                            this.showMessage();
                        } else {
                            this.$message({ message: r.msg, type: 'warning' });
                        }
                    }).finally(f => {
                        this.loading = false;
                    });
                } else {
                    this.loading = false;
                    return false;
                }
            });
        },

        showMessage () {
            this.dialogVisible = true;
        },

        handleClose (done) {
            done();
        },

        // 鼠标按下
        slideBegin: function (event) {
            if (this.isFocus) return;
            this.startBegin = Date.now();

            console.log(this.startBegin);
            // if (!this.dragToolsBox) {
            //     return;
            // }
            let startX = event.pageX ? event.pageX : event.touches[0].pageX;
            let startY = event.pageY ? event.pageY : event.touches[0].pageY;
            let endX;
            let endY;
            let _this = this;
            let oDiv = this.$refs.toolsArea;
            let oEvent = event;
            // 获取边界到鼠标的距离
            let distX = oEvent.clientX ? oEvent.clientX - oDiv.offsetLeft : oEvent.changedTouches[0].clientX - oDiv.offsetLeft;
            let distY = oEvent.clientY ? oEvent.clientY - oDiv.offsetTop : oEvent.changedTouches[0].clientY - oDiv.offsetTop;
            // oDiv.onmousedown = function (evt) {
            //     let e = evt || event;
            //     startX = e.pageX;
            //     startY = e.pageY;
            // };
            if (event.type === 'touchstart') {
                let move = (ev) => {
                    _this.slideMove(ev || event, distX, distY, oDiv,);
                };
                let end = (evt) => {
                    let e = evt || event;
                    endX = e.pageX;
                    endY = e.pageY;
                    if (!e.pageX && e.touches && e.touches[0] && e.touches[0].pageX && e.touches[0].pageY) {
                        endX = e.touches[0].pageX;
                        endY = e.touches[0].pageY;
                    }
                    let d = Math.sqrt((startX - endX) * (startX - endX) + (startY - endY) * (startY - endY));
                    if (d === 0 || d < 7 || !endX) {
                        _this.canClick = true;
                        console.log('执行了点击事件');
                    } else {
                        _this.canClick = false;
                        console.log('执行了拖拽事件');
                    }
                    _this.$el.removeEventListener('touchmove', move, false);
                    _this.$el.removeEventListener('touchend', end, false);
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
                _this.$el.addEventListener('touchmove', move, false);
                _this.$el.addEventListener('touchend', end, false);
            } else {
                document.onmousemove = function (ev) {
                    _this.slideMove(ev || event, distX, distY, oDiv, 'pc');
                };
                document.onmouseup = function (evt) {
                    let e = evt || event;
                    endX = e.pageX;
                    endY = e.pageY;
                    if (!e.pageX && e.touches && e.touches[0] && e.touches[0].pageX && e.touches[0].pageY) {
                        endX = e.touches[0].pageX;
                        endY = e.touches[0].pageY;
                    }
                    let d = Math.sqrt((startX - endX) * (startX - endX) + (startY - endY) * (startY - endY));
                    if (d === 0 || d < 7 || !endX) {
                        _this.canClick = true;
                        console.log('执行了点击事件');
                    } else {
                        _this.canClick = false;
                        console.log('执行了拖拽事件');
                    }
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            }
        },
        // 鼠标滑动
        slideMove: function (event, distX, distY, oDiv, type) {
            let _this = this;
            let oEvent = event;
            window.getSelection().empty();
            oEvent.stopPropagation();
            let x = 0;
            let y = 0;
            let clientX = oEvent.clientX ? oEvent.clientX : oEvent.changedTouches[0].clientX;
            let clientY = oEvent.clientY ? oEvent.clientY : oEvent.changedTouches[0].clientY;
            // if (type === 'pc') {
            //     x = oEvent.clientX - distX;
            //     y = oEvent.clientY - distY;
            // } else {
            //     x = oEvent.changedTouches[0].clientX - distX;
            //     y = oEvent.changedTouches[0].clientY - distY;
            // }
            x = clientX - distX;
            y = clientY - distY;
            let bodyModel = document.body.getBoundingClientRect();
            let toolArea = _this.$refs['toolsArea'].getBoundingClientRect();
            let bottomHeight = bodyModel.height - toolArea.height;
            let rightHeight = bodyModel.width - toolArea.width;
            if (x < 0) {
                x = 0;
            }
            if (y < 0) {
                y = 0;
            }
            if (y > bottomHeight) {
                y = bottomHeight;
            }
            if (x > rightHeight) {
                x = rightHeight;
            }
            if (!(oDiv.style.left === `${this.sideMargin}px` && x === this.sideMargin && oDiv.style.bottom === `${this.bottomMargin}px`)) {
                oDiv.style.left = 'auto';
                oDiv.style.right = `${bodyModel.width - (toolArea.width + x)}px`;
                oDiv.style.bottom = `${bodyModel.height - (toolArea.height + y)}px`;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.web-004-page {
    .center-container {
        background: linear-gradient(#E0E4FF 0%, #FFFFFF 100%);
        // text-align: center;
        &-top-title, &-middle-title, &-bottom-title {
            font-weight: 600;
            font-size: 32px;
            color: #141414;
            line-height: 45px;
            padding: 40px 0;
            margin: 0 auto;
            text-align: center;
        }
        &-top-title {
            padding-top: 50px;
        }
        &-top {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 40px;
            &-item {
                width: 1213px;
                background: linear-gradient( 180deg, #FFFFFF 0%, rgba(255,255,255,0.2) 100%);
                border-radius: 12px;
                padding: 30px;
                margin: 0 auto 30px;
                &:last-child {
                    margin-bottom: 0;
                }
                .item-subtitle {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 3px;
                    font-size: 24px;
                    color: #1252FF;
                    font-weight: 600;
                    img {
                        width: 81px;
                        margin-right: 13px;
                    }
                }

                .item-content {
                    .item-content-div {
                        display: inline-flex;
                        align-items: center;
                        margin-right: 76px;
                        width: 320px;
                        margin-top: 40px;
                        &:nth-child(3n) {
                            margin-right: 0;
                        }
                        img {
                            width: 51px;
                            height: 51px;
                            margin-right: 20px;
                        }
                    }
                }
            }
        }

        &-middle {
            margin-bottom: 40px;
            &-content {
                &-item {
                    width: 1213px;
                    display: block;
                    margin: 0 auto 51px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }

        &-bottom {
            margin-bottom: 40px;
            text-align: center;
            &-content-item {
                margin-right: 40px;
                width: 273px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
    .ruleForm {
        position: fixed;
        right: 18px;
        bottom: 120px;
        width: 263px;
        height: 283px;
        z-index: 30;
        background: #fff;
        padding: 0 20px;
        box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.2);
        border-radius: 12px;
        .title {
            font-size: 18px;
            font-weight: bold;
            text-align: center;
            line-height: 51px;
        }
        ::v-deep {
            .el-input__inner {
                border: 1px solid #C5C5C7;
                border-radius: 4px;
                // box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.2);
                line-height: 34px;
                height: 34px;
            }

            .el-form-item__label {
                line-height: 20px;
                padding: 0;
                font-size: 14px;
                color: #343444;
                margin-bottom: 10px;
            }
            .el-form-item__error {
                line-height: 20px;
            }
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
        }

        .img {
            width: 100%;
            text-align: center;
        }

        .submit {
            background: linear-gradient( 180deg, #FF8800 0%, #FE5000 100%);
            // box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.2);
            border-radius: 4px;
            width: 100%;
            font-size: 14px;
            color: #FFFFFF;
            margin-bottom: 20px;
            height: 40px;
            border: none;
            &:hover,&:active {
                border-color: none;
            }
        }
    }
    .qr-container {
        text-align: center;
        width: 192px;
        background: #D8D8D8;
        box-shadow: 0px 6 12px 0px rgba(0,0,0,0.2);
        border-radius: 4px;
        user-select: none;
        margin: 0 auto;
    }

    .scan-code {
        text-align: center;
        line-height: 40px;
        font-size: 12px;
    }
}
</style>
